import { Input, Modal, Typography } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const { Title } = Typography;

const SearchModal = ({
  visible,
  searchQuery,
  onSearchChange,
  onClose
}) => {
  return (
    <Modal
      title="Search"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
    >
      <Input 
        prefix={<SearchOutlined />}
        placeholder="Search result to highlight it in Transcription or Notes"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="mb-4 w-full"
      />
      
      {searchQuery && (
        <>
          <div className="mb-4">
            <Title level={5}>Transcription</Title>
            <div className="p-3 bg-gray-100 rounded">
              <p>... you mentioned feeling more tired than usual. Do you think this could be related to any <span className="bg-yellow-200 py-0 px-0.5">recent illness</span>?</p>
              <p>Possibly. I had a bad cold a couple of weeks ago......</p>
            </div>
          </div>
          
          <div className="mb-4">
            <Title level={5}>Notes</Title>
            <div className="p-3 bg-gray-100 rounded">
              <p>... I've been trying to get back into my routine, but it's been hard since that <span className="bg-yellow-200 py-0 px-0.5">recent illness</span>. That makes sense—it can take time to regain energy........</p>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};

export default SearchModal;